<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>分类列表</span>
        <el-button class="tz-r tz-create-btn" round @click="jump('/document')"
          >返回</el-button
        >
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="editState = true"
          >创建分类</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <!-- <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入分类"
            v-model="dictTypeValue"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row> -->
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="dictList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeDict"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import {
  classifyList,
  deleteClassify,
  updateClassify,
  saveClassify
} from '@/api/document'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      editUnit: {},
      dictList: [],
      columns: [
        {
          field: 'sort',
          title: '序号',
          width: '80'
        },
        {
          field: 'content',
          title: '分类名称'
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                this.editUnit = JSON.parse(JSON.stringify(row))
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    // handleSizeChange(val) {
    //   this.size = val
    //   this.getDictList()
    // },
    // handleCurrentChange(val) {
    //   this.page = val
    //   this.getDictList()
    // },
    // 列表
    getDictList() {
      let dictparams = {
        type: '1'
        // pageSize: this.size,
        // pageNum: this.page
      }
      classifyList(dictparams).then((res) => {
        if (res.code == 200) {
          console.log(res)
          if (res.data.length > 0) {
            let dictList = res.data
            dictList.forEach((el, index) => {
              el['sort'] = index + 1
            })
            this.dictList = dictList
          }
        }
      })
    },
    // 编辑
    changeDict(infos) {
      console.log(infos)
      this.$loading({
        text: '更新中'
      })
      // 编辑
      if (infos.id) {
        let updateparams = {
          // ...infos
          id: infos.id,
          type: '1',
          content: infos.content
        }
        updateClassify(updateparams).then((res) => {
          console.log(res.data, '更新')
          this.$loading().close()
          if (res.code == 200) {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
            this.getDictList()
          } else {
            this.$message({
              type: 'error',
              message: '更新失败!'
            })
          }
          this.editState = false
        })
      } else {
        // 新增
        let updateparams = {
          type: '1',
          content: infos.content
        }
        saveClassify(updateparams).then((res) => {
          console.log(res.data, '更新')
          this.$loading().close()
          if (res.code == 200) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.getDictList()
          } else {
            this.$message({
              type: 'error',
              message: '保存失败!'
            })
          }
          this.editState = false
        })
      }
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteClassify(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
    // // 模糊查询
    // dictSearch() {
    //   this.page = 1
    //   this.getDictList()
    // }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style></style>
